import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import { PopupProps } from '../PopupsInterface';
import { Button, ClassNameMap } from '@mui/material';
import DesktopDialog from 'components/commons/dialog';

const ConfirmActionPopup = ({ onClose, onSubmit, title }: PopupProps) => {
  const { t } = useTranslation(['actions']);
  const classes: ClassNameMap = useStyles();

  return (
    <DesktopDialog
      open
      classes={{ paper: classes.confirmPopup }}
      onClose={() => onClose()}
      DialogTitleProps={{ style: { textAlign: 'center' } }}
      title={title ?? ''}
    >
      <div className={classes.actionGroup}>
        <Button variant={'contained'} color={'primary'} onClick={onSubmit}>
          {t('actions:confirm')}
        </Button>
        <Button onClick={onClose} variant={'outlined'} color={'primary'}>
          {t('actions:cancel')}
        </Button>
      </div>
    </DesktopDialog>
  );
};

export default ConfirmActionPopup;
